import {  getDataFromApi } from './artistutils'

export class Route {

    route = []

    CookieName = "ROUTE";

    clear() {
        this.route = [];
    }


    getCookie() {
        //console.log("Getting cookie for name:", this.CookieName);
        const cookieMatch = document.cookie.match(new RegExp('(^| )' + this.CookieName + '=([^;]+)'));
        if (cookieMatch) {
            try {
                // Use index [2] to get the value group from the Regex
                return JSON.parse(decodeURIComponent(cookieMatch[2]));
            } catch (e) {
                console.error("Error parsing cookie array", e);
                return [];
            }
        }
        return [];
    }

    async setRoute(routes) {
        this.route = []
        routes.forEach(item => {
            this.route.push(parseInt(item))
        })
        await this.saveRoute()
    }

    async fetchRoute() {
        const data = await getDataFromApi("MemberApi", "maproute", "")
        if (data && data.member && data.route) {
            this.route = data.route
        } else {
            this.route = this.getCookie()
        }
        //console.log("route", this.route)
    }

    saveCookie() {
        const jsonString = JSON.stringify(this.route);
        const days = 400;
        const maxAge = days * 24 * 60 * 60;

        document.cookie = `${this.CookieName}=${encodeURIComponent(jsonString)}; max-age=${maxAge}; path=/; SameSite=Lax; Secure`;
        //console.log("cookie set to ", jsonString)
    }

    async saveRoute() {
        this.saveCookie()
        try {
            //console.log("Saving route to API", this.route);
            const response = await fetch('/api/MemberApi/maproute', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.route) // Body data must be a string
            })

            // Check if the request was successful
            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json(); // Wait for the JSON body to parse
            //console.log("Save Route from API", data);

        } catch (error) {
            console.error("Failed to fetch route:", error);
        }
    }

    async init() {
        await this.fetchRoute()
    }
}

